<template>
  <div class="user-guidance">
    <tooltipLine
      :visible="!($store.state.user.hasBindData && $store.state.user.hasBindData.isExistShop)"
      :content="$t('system::common::no_authority_tooltip')"
    ></tooltipLine>
    <!-- <el-card>
      <div class="header">
        <div class="title-wrap">
          <p class="title">{{ $t('user-guidance::title') }}</p>
          <p class="text">{{ $t('user-guidance::text') }}</p>
        </div>
        <img src="@/assets/images/userGuidance/chat.png" />
      </div>
    </el-card> -->

    <template v-if="!guidanced && $store.state.user.userId == $store.state.user.merchantId">
      <div class="operation">
        <span class="text">
          {{ $t('user-guidance::guide::title', { step: elTabPaneList.filter(item => !item.complete).length }) }}
        </span>
        <el-button size="small" class="btn" @click="handleCloseGuidance">
          {{ $t('user-guidance::guide::close') }}
        </el-button>
      </div>
      <div class="content">
        <el-tabs :value="tabName" tab-position="left" @tab-click="handleTabClick">
          <el-tab-pane
            v-for="item in elTabPaneList"
            :name="item.name"
            :key="item.index"
            style="text-align: left; background: white; width: 100%"
            :disabled="!($store.state.user.hasBindData && $store.state.user.hasBindData.isExistShop)"
          >
            <div slot="label" class="box" :class="{ choose: item.index == chooseIndex }">
              <i class="el-icon-success" v-if="item.complete"></i>
              <span class="yuan" v-else>
                {{ item.index }}
              </span>
              <span class="title">{{ item.title }}</span>
            </div>
            <div class="content-box">
              <div class="content-wrap">
                <div class="text">
                  {{ item.text }}
                </div>
                <div class="tip">
                  {{ item.tip }}
                </div>
                <el-button
                  class="btn"
                  size="small"
                  v-buried="{ event: 'GuideButtonClick', buttonName: btn.buttonName }"
                  v-auth="btn.auth"
                  @click="handleBtnClick(btn.click)"
                  v-for="(btn, index) in item.buttons"
                  :key="index"
                >
                  {{ btn.btnText }}
                </el-button>
              </div>
              <img :src="item.imgUrl" />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>

    <div class="guidenced-content" v-else>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="17">
          <el-card class="analysis">
            <div class="title">{{ $t('user-guidance::data::sales_title') }}</div>
            <div class="list" style="padding: 24px 0 0 24px">
              <div class="box box-border" v-for="item in analysisList" :key="item.text">
                <div class="text">
                  {{ $dataCheck(item.text) }}
                  <span v-if="item.currency">({{ item.currency }})</span>
                </div>
                <el-popover placement="bottom-start" trigger="hover">
                  <div class="card-content__popover">
                    <div class="card-content__contentleft">
                      <div class="card-content__top">{{ $t('system::common::current_num') }}: {{ item.number }}</div>
                      <div>{{ $t('system::common::statistics_days') }}: {{ item.statisticsDays }}</div>
                    </div>
                    <div>
                      <div class="card-content__top">{{ $t('system::common::last_num') }}: {{ item.lastNumber }}</div>
                      <div>
                        {{ $t('system::common::compare_result') }}:
                        <span v-if="item.rate" :style="item.rate < 0 ? 'color: #16C97B' : 'color: #F23E55'">
                          {{ $dataCheck(item.rate) }}%
                        </span>
                        <span v-else>{{ $dataCheck(item.rate) }}%</span>
                      </div>
                    </div>
                  </div>
                  <div slot="reference" class="number font-manrope">
                    {{ $dataCheck(item.number, 0) }}
                  </div>
                </el-popover>
                <span class="rate" :style="item.rate < 0 ? 'color:green' : ''">
                  <span class="font-manrope">{{ $dataCheck(item.rate) }}</span>
                  %
                  <i class="iconfont iconChevron-Top" style="transform: rotate(180deg)" v-if="item.rate < 0"></i>
                  <i class="iconfont iconChevron-Top" v-else></i>
                </span>
              </div>
            </div>
          </el-card>
          <el-card class="analysis">
            <div class="title">
              {{ $t('user-guidance::data::ad_title') }}
              <span v-if="!($store.state.user.hasBindData && $store.state.user.hasBindData.isExistAds)">
                <span style="color: #8a909d; margin-right: 8px; margin-left: 16px">
                  {{ $t('user-guidance::data::ad_tip') }}
                </span>
                <el-button type="text" style="padding: 0" @click="faceBookModalShow = true">
                  {{ $t('ad-analysis::auth_fb') }}
                </el-button>
                <el-button type="text" style="padding: 0" @click="googleModalShow = true">
                  {{ $t('ad-analysis::auth_google') }}
                </el-button>
              </span>
            </div>
            <div class="list">
              <div class="box-wrap" v-for="item in adverList" :key="item.text">
                <div class="box">
                  <div class="text">
                    {{ $dataCheck(item.text) }}
                    <span v-if="item.currency">({{ item.currency }})</span>
                  </div>
                  <el-popover placement="bottom-start" trigger="hover">
                    <div class="card-content__popover">
                      <div class="card-content__contentleft">
                        <div class="card-content__top">{{ $t('system::common::current_num') }}: {{ item.number }}</div>
                        <div>{{ $t('system::common::statistics_days') }}: {{ item.statisticsDays }}</div>
                      </div>
                      <div>
                        <div class="card-content__top">{{ $t('system::common::last_num') }}: {{ item.lastNumber }}</div>
                        <div>
                          {{ $t('system::common::compare_result') }}:
                          <span v-if="item.rate" :style="item.rate < 0 ? 'color: #16C97B' : 'color: #F23E55'">
                            {{ $dataCheck(item.rate) }}%
                          </span>
                          <span v-else>{{ $dataCheck(item.rate) }}%</span>
                        </div>
                      </div>
                    </div>
                    <div slot="reference" class="number font-manrope">
                      {{ $dataCheck(item.number, 0) }}
                    </div>
                  </el-popover>
                  <span class="rate" :style="item.rate < 0 ? 'color:green' : ''">
                    <span class="font-manrope">{{ $dataCheck(item.rate) }}</span>
                    %
                    <i class="iconfont iconChevron-Top" style="transform: rotate(180deg)" v-if="item.rate < 0"></i>
                    <i class="iconfont iconChevron-Top" v-else></i>
                  </span>
                </div>
                <div class="box-img">
                  <img :src="item.img" />
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="7">
          <el-card class="action">
            <div class="title">
              <img class="calendar" src="@/assets/images/userGuidance/calendar.png" alt="" />
              <div>
                <span class="nowDay">{{ nowDay }}</span>
                <p class="date">{{ nowDate }}</p>
              </div>
            </div>
            <div class="list">
              <el-row>
                <template v-for="item in actionList">
                  <el-col class="box" :span="8" :key="item.index" v-if="!item.auth || authPromise(item.auth)">
                    <div class="action-wrap" @click="handleActionClick(item.index)">
                      <div class="img-wrap" :style="{ background: item.bgColor }">
                        <img :src="item.url" alt="" />
                      </div>
                      <p class="text">{{ item.text }}</p>
                    </div>
                  </el-col>
                </template>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- 榜单 -->
      <el-row :gutter="20">
        <el-col :span="24" :xl="12" :lg="12" :md="24">
          <el-card class="send-order">
            <div>
              <el-button
                style="width: 96px"
                size="small"
                :type="tableParams.type === 0 ? 'primary' : ''"
                @click="changeTableType(0)"
              >
                {{ $t('user-guidance::data::table_热销榜') }}
              </el-button>
              <el-button
                style="width: 96px"
                size="small"
                :type="tableParams.type === 1 ? 'primary' : ''"
                @click="changeTableType(1)"
              >
                {{ $t('user-guidance::data::table_退款榜') }}
              </el-button>
            </div>
            <el-row style="margin: 16px 0px; display: flex; align-items: center; font-size: 12px">
              <el-col :span="24">
                <el-select
                  style="width: 150px; margin-right: 16px"
                  v-model="tableParams.shopId"
                  :popperAppendToBody="false"
                  :placeholder="$t('system::common::select_placeholder')"
                  @change="getList"
                >
                  <el-option
                    v-for="item in selectShopList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>

                <el-date-picker
                  style="width: 300px"
                  :clearable="false"
                  @change="changeTableDate"
                  v-model="selectTableDate"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-col>
            </el-row>
            <div style="min-height: 260px">
              <z-table
                :columns="salesColumns"
                :customDefault="{ height: '325px' }"
                :data="dataList"
                height="325px"
                v-loading="loading"
                ref="table"
                v-if="tableParams.type === 0"
              >
                <template #index="scope">
                  <span v-if="scope.$index > 2">{{ scope.$index + 1 }}</span>
                  <img :src="rankImg[scope.$index]" style="height: 24px; width: 24px" v-else />
                </template>
                <template #spuImage="{ row }">
                  <el-image :src="row.spuImage" class="goods-image"></el-image>
                </template>
                <template #spuId="{ row }">
                  {{ $dataCheck(row.spuId) }}
                </template>
                <template #saleAccount="{ row }">
                  {{ $dataCheck(row.saleAccount) }}
                </template>
                <template #saleAmount="{ row }">
                  {{ $dataCheck(row.saleAmount) }}
                </template>
                <template #refundAccount="{ row }">
                  {{ $dataCheck(row.refundAccount) }}
                </template>
                <template #availableInventory="{ row }">
                  {{ $dataCheck(row.availableInventory) }}
                </template>
              </z-table>
              <z-table
                :columns="refundColumns"
                :customDefault="{ height: '325px' }"
                :data="dataList"
                height="325px"
                v-loading="loading"
                ref="table"
                v-if="tableParams.type === 1"
              >
                <template #index="scope">
                  <span v-if="scope.$index > 2">{{ scope.$index + 1 }}</span>
                  <img :src="rankImg[scope.$index]" style="height: 24px; width: 24px" v-else />
                </template>
                <template #imageUrl="{ row }">
                  <el-image :src="row.imageUrl" class="goods-image"></el-image>
                </template>
                <template #spuId="{ row }">
                  {{ $dataCheck(row.spuId) }}
                </template>
                <template #saleAccount="{ row }">
                  {{ $dataCheck(row.saleAccount) }}
                </template>
                <template #refundAmount="{ row }">
                  {{ $dataCheck(row.refundAmount) }}
                </template>
                <template #refundAccount="{ row }">
                  {{ $dataCheck(row.refundAccount) }}
                </template>
                <template #refundRate="{ row }">
                  {{ $dataCheck(row.refundRate) }}
                </template>
              </z-table>
            </div>
          </el-card>
        </el-col>

        <!-- 销售分析 -->
        <el-col :span="24" :xl="12" :lg="12" :md="24">
          <el-card class="sale-analysis">
            <p class="title">{{ $t('user-guidance::data::analysis_title') }}</p>
            <el-row :gutter="12" style="padding: 0 30px">
              <el-col :span="24">
                <el-row style="margin-bottom: 8px; display: flex; align-items: center; font-size: 12px">
                  <el-col :span="24">
                    <el-select
                      style="width: 150px; margin-right: 16px"
                      :popperAppendToBody="false"
                      v-model="selectedShop"
                      :placeholder="$t('system::common::select_placeholder')"
                      @change="handlerSelectChange"
                    >
                      <el-option
                        v-for="item in selectShopList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-date-picker
                      style="width: 300px"
                      :clearable="false"
                      @change="handlerDateChange"
                      v-model="selectDate"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="~"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="padding: 0 30px">
              <el-col :span="24">
                <reportCard :config="saleTrendData" v-loading="reportCardLoading"></reportCard>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 关闭引导弹窗 -->
    <closeModal ref="closeModal" @closeGuidance="closeGuidance"></closeModal>
    <!-- 新建店铺弹窗 -->
    <createShopModal :isDetail="false" :isNew="true" ref="createShopModal"></createShopModal>
    <!-- faceBook -->
    <faceBookModal v-model="faceBookModalShow" :drawRow="drawRow" @save="onSave"></faceBookModal>
    <!-- google -->
    <googleModal v-model="googleModalShow" :drawRow="drawRow" @save="onSave"></googleModal>
    <!-- email弹窗 -->
    <emailModal v-model="drawerVisable" @save="onSave" :drawRow="drawRow"></emailModal>
    <!-- 支付设置弹窗 -->
    <paySettingModal
      v-model="payDialogVisible"
      :dialogType="'add'"
      :shopList="shopList"
      @closeDialog="onSave"
    ></paySettingModal>
    <sendModal v-model="sendModalShow" @closeDialog="onSave"></sendModal>
    <!-- 发货弹窗 -->
  </div>
</template>

<script>
import { _local } from '@/utils/storage'
import moment from 'moment'
import { formatNumberMix } from '@/utils'
import { getShopList } from '@/server/product'
import { getSalesRankTable, getRefundRankTable } from '@/server/data'
import closeModal from './components/close-modal'
import createShopModal from '../store/components/editDialog'
import faceBookModal from '../marketing/components/edit-modal'
import googleModal from '../marketing/components/google-modal'
import emailModal from '../after-sales/components/email-modal'
import bindModal from './components/bind-modal'
import welcomeModal from './components/welcome-modal'
import paySettingModal from '../store/paySetting/handleDialog'
import Cookies from 'js-cookie'
import sendModal from '../store/logisticsSetting/handleDialog'
import { getTransactionData, postAdData, getTodayAnalysis } from '@/server/data'
import { pickerOptions } from '@/utils/datepickerConfig'
import reportCard from '@/components/data-analysis/report'
import { salesColumns, refundColumns, elTabPaneList, actionList, analysisList, adverList } from './config'
export default {
  name: 'user-guidance',
  components: {
    closeModal,
    createShopModal,
    faceBookModal,
    emailModal,
    bindModal,
    paySettingModal,
    welcomeModal,
    sendModal,
    reportCard,
    googleModal,
  },
  data() {
    return {
      nowDate: moment(new Date()).locale(this.$store.state.language).format('LL'),
      nowDay: moment(new Date()).locale(this.$store.state.language).format('dddd'),
      reportCardLoading: false,
      saleTrendData: [], // 总体成交趋势图数据:
      selectedShop: '',
      pickerOptions: {
        ...pickerOptions,
        disabledDate: time => {
          return time.getTime() >= Date.parse(new Date())
        },
      },
      loading: false,
      dataList: [],
      tableParams: {
        startDate: moment().subtract(29, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        type: 0,
        shopId: '',
      },
      selectTableDate: [moment().subtract(29, 'days'), moment()],
      salesColumns: salesColumns,
      refundColumns: refundColumns,
      sendModalShow: false,
      shopList: [],
      selectShopList: [{ label: this.$t('system::common::select_all'), value: '' }],
      payDialogVisible: false,
      chooseIndex: 1,
      elTabPaneList: [...elTabPaneList],
      bindShopModalShow: false,
      faceBookModalShow: false,
      googleModalShow: false,
      drawerVisable: false,
      drawRow: {
        type: 'add',
        item: {},
      },
      tabName: 'isExistShop',
      analysisList: analysisList,
      adverList: adverList,
      actionList: actionList,
      selectDate: [moment().subtract(29, 'days'), moment()],
      params: {
        start_date: moment().subtract(29, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        adSource: 0,
      },
      hasClose: _local.get('hasClose') || false,
      rankImg: [
        require('@/assets/images/userGuidance/first.png'),
        require('@/assets/images/userGuidance/second.png'),
        require('@/assets/images/userGuidance/third.png'),
      ],
    }
  },
  watch: {
    guidanced: {
      handler: function (bool) {
        this.getCompleteList(() => {
          this.getShopList()
          if (bool) {
            this.getList()
            this.getSaleTrendData()
            this.getAdData()
            this.getTodayAnalysis()
          }
        })
      },
      immediate: true,
    },
  },
  methods: {
    changeTableType(type) {
      this.tableParams.type = type
      this.getList()
    },
    changeTableDate(date) {
      this.tableParams.startDate = moment(date[0]).format('YYYY-MM-DD')
      this.tableParams.endDate = moment(date[1]).format('YYYY-MM-DD')
      this.getList()
    },
    async getTodayAnalysis() {
      let obj = {}
      const { data } = await getTodayAnalysis(obj)
      if (data.code === this.$code) {
        this.analysisList[0]['number'] = data.data.datas[0].payTotalAmount || 0
        this.analysisList[0]['rate'] = data.data.datas[0].payTotalAmountRatio || ''
        this.analysisList[0]['statisticsDays'] = data.data.datas[0].statisticsDays || ''
        this.analysisList[0]['lastNumber'] = data.data.datas[0].lastPayTotalAmount || 0
        this.analysisList[1]['number'] = data.data.datas[0].orderCnt || 0
        this.analysisList[1]['rate'] = data.data.datas[0].orderCntRatio || ''
        this.analysisList[1]['statisticsDays'] = data.data.datas[0].statisticsDays || ''
        this.analysisList[1]['lastNumber'] = data.data.datas[0].lastOrderCnt || 0
        this.analysisList[2]['number'] = data.data.datas[0].pendingOrderCnt || 0
        this.analysisList[2]['lastNumber'] = data.data.datas[0].lastPendingOrderCnt || 0
        this.analysisList[2]['statisticsDays'] = data.data.datas[0].statisticsDays || ''
        this.analysisList[3]['number'] = data.data.datas[0].pendingAfterSaleOrder || 0
        this.analysisList[3]['lastNumber'] = data.data.datas[0].lastPendingAfterSaleOrder || 0
        this.analysisList[3]['rate'] = data.data.datas[0].pendingAfterSaleOrderRatio || ''
        this.analysisList[3]['statisticsDays'] = data.data.datas[0].statisticsDays || ''
      }
    },
    closeGuidance() {
      this.hasClose = true
      _local.set('hasClose', true)
      this.guidanced = true
    },
    async getCompleteList(fn) {
      // 引导是否完成
      let data = this.$store.state.user.hasBindData
      if (!data) {
        await this.$store.dispatch('getBindData')
      }
      data = this.$store.state.user.hasBindData
      for (let key in data) {
        this.elTabPaneList.find(item => item.name === key).complete = !!data[key]
      }
      if (fn) fn()
    },
    // 按钮触发事件
    handleActionClick(index) {
      switch (index) {
        case 1:
          this.$store.commit('setShopVisiable', { visiable: true })
          break
        case 2:
          this.$router.push('/in-box')
          break
        case 3:
          this.$router.push('/store')
          break
        case 4:
          this.$router.push('/order')
          break
        case 5:
          this.$router.push('/products-info/add/add')
          break
        case 6:
          this.$router.push('/add-after-order')
          break
        default:
          break
      }
    },
    // 获取广告数据
    async getAdData() {
      const { data } = await postAdData({
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        adSource: 0,
      })
      if (data.code === this.$code) {
        this.adverList[0].number = formatNumberMix(data.data.datas[0].saleAmountAd, 2, ',') || 0
        this.adverList[0].lastNumber = formatNumberMix(data.data.datas[0].lastSaleAmountAd, 2, ',') || 0
        this.adverList[0].statisticsDays = data.data.datas[0].statisticsDays || ''
        this.adverList[0].rate = formatNumberMix(data.data.datas[0].saleAmountAdRatio, 2, ',') || ''
        this.adverList[1].number = formatNumberMix(data.data.datas[0].adCost, 2, ',') || 0
        this.adverList[1].lastNumber = formatNumberMix(data.data.datas[0].lastAdCost, 2, ',') || 0
        this.adverList[1].statisticsDays = data.data.datas[0].statisticsDays || ''
        this.adverList[1].rate = formatNumberMix(data.data.datas[0].adCostRatio, 2, ',') || ''
        this.adverList[2].number = formatNumberMix(data.data.datas[0].roi, 2, ',') || 0
        this.adverList[2].lastNumber = formatNumberMix(data.data.datas[0].lastRoi, 2, ',') || 0
        this.adverList[2].statisticsDays = data.data.datas[0].statisticsDays || ''
        this.adverList[2].rate = formatNumberMix(data.data.datas[0].roiRatio, 2, ',') || ''
      }
    },
    async getList() {
      this.loading = true
      this.dataList = []
      const { shopId, startDate, endDate, type } = this.tableParams
      let params = { startDate, endDate, pageNum: 1, pageSize: 10 }
      if (shopId) {
        params = { ...params, shopId }
      }

      const { data } = await (type === 0 ? getSalesRankTable({ ...params }) : getRefundRankTable({ ...params }))
      if (data.code === this.$code) {
        this.dataList = Array.isArray(data.data.datas) ? data.data.datas : []
      }
      this.loading = false
    },
    handleCloseGuidance() {
      this.$refs.closeModal.show()
    },
    handleTabClick(index) {
      this.chooseIndex = Number(index.index) + 1
    },
    handleBtnClick(index) {
      switch (index) {
        // 店铺弹窗
        case 'bindShop':
          this.$store.commit('setShopVisiable', { visiable: true })
          break
        // fb广告账号弹窗
        case 'bindFackbook':
          this.faceBookModalShow = true
          break
        // google广告账号弹窗
        case 'bindGoogle':
          this.googleModalShow = true
          break
        // 物流商绑定弹窗
        case 'bindLogistics':
          this.sendModalShow = true
          break
        // 售后邮箱弹窗
        case 'bindEmail':
          this.drawerVisable = true
          break
        // 支付弹窗
        case 'bindPaypal':
          this.payDialogVisible = true
          break
      }
    },
    async onSave() {
      await this.$store.dispatch('getBindData')
      this.getCompleteList()
    },
    // 获取店铺列表
    async getShopList() {
      const { data } = await getShopList()
      if (Array.isArray(data.data)) {
        this.shopList = data.data.map(item => {
          return {
            label: item.shopName,
            value: item.shopId,
          }
        })
        this.selectShopList = [...this.selectShopList, ...this.shopList]
      }
    },
    handlerSelectChange(value) {
      this.selectedShop = value
      this.getSaleTrendData()
    },
    handlerDateChange(value) {
      this.params.start_date = moment(value[0]).format('YYYY-MM-DD')
      this.params.end_date = moment(value[1]).format('YYYY-MM-DD')
      this.getSaleTrendData()
    },
    async getSaleTrendData() {
      this.reportCardLoading = true
      let obj = {
        ...this.params,
      }
      if (this.selectedShop) obj['shop_id'] = this.selectedShop
      const { data } = await getTransactionData(obj)
      if (data.code === this.$code) {
        this.saleTrendData = this.setSaleTrendData(data.data.datas)
      }
      this.reportCardLoading = false
    },
    setSaleTrendData(data = []) {
      return {
        type: 'line',
        // title: '总体成交趋势',
        ref: 'lineChart',
        height: '280px',
        chart: {
          legend: {
            show: true,
            data: [this.$t('user-guidance::data::analysis_bar'), this.$t('user-guidance::data::analysis_line')],
          },
          xAxis: {
            data: data.map(item => item.date),
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#DCDFE6',
                  type: 'dashed',
                },
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999',
              },
            },
            {
              type: 'value',
              min: 0,
              splitLine: {
                show: false,
              },
              axisLabel: {
                margin: 16,
                color: '#999999',
                formatter: '{value} %',
              },
            },
          ],
          series: [
            {
              name: this.$t('user-guidance::data::analysis_bar'),
              type: 'bar',
              data: data && data.map(item => Number(item.saleAmount)),
            },
            {
              name: this.$t('user-guidance::data::analysis_line'),
              type: 'line',
              data: data && data.map(item => Number(item.customerPricePer)),
            },
          ],
        },
      }
    },
  },
  computed: {
    guidanced: {
      get() {
        if (this.hasClose) {
          // 关闭引导
          return true
        } else {
          return this.$store.state.user.userId == this.$store.state.user.merchantId
            ? this.elTabPaneList.every(item => item.complete === true)
            : true
        }
      },
      set(value) {
        return value
      },
    },
  },
}
</script>

<style lang="scss">
.card-content {
  &__popover {
    font-size: 14px;
    padding: 12px;
    font-family: MicrosoftYaHei;
    color: #010517;
    line-height: 14px;
    display: flex;
    align-items: center;
  }
  &__contentleft {
    margin-right: 40px;
  }
  &__top {
    margin-bottom: 24px;
  }
}
</style>

<style lang="scss" scoped>
::v-deep {
  .pagination-container {
    display: none;
  }
  .el-table th {
    background: #f0f2f5;
  }
  .el-card__body {
    padding: 0px;
  }
  .el-tabs__active-bar {
    background: white;
  }
  .el-tabs__item {
    padding: 0px 0px 0px 0px !important;
    height: 50px;
    color: #010517;
    line-height: 50px;
  }
  .el-tabs--left .el-tabs__item.is-left {
    text-align: left;
    height: 70px;
    line-height: 70px;
    border-right: 1px solid #dcdfe6;
    border-top: 1px solid #dcdfe6;
    &:nth-child(2) {
      border-top: none;
    }
  }
  .el-tabs--left .el-tabs__header.is-left {
    margin-right: 0px;
  }
  .el-tabs--left,
  .el-tabs--right {
    border-radius: 6px;
  }
}

.header {
  width: 100%;
  height: 118px;
  font-size: 0;
  background-image: url('../../assets/images/userGuidance/10.png');
  background-size: 100%;
  background-position: right -1px;
  background-repeat: no-repeat;
  display: flex;
  justify-content: space-between;
  padding: 0 24px 0 40px;
  box-sizing: border-box;
  .title-wrap {
    margin-top: 32px;
    .title {
      font-size: 20px;
      font-weight: bold;
    }
    .text {
      font-size: 14px;
      color: #999999;
      margin-top: 12px;
    }
  }
  img {
    width: 165px;
    height: 80px;
    margin-top: 19px;
  }
}
.operation {
  display: flex;
  justify-content: space-between;
  margin: 32px 0px 16px;
  .text {
    font-size: 20px;
  }
  .btn {
    width: 100px;
  }
}
.content {
  width: 100%;
  color: #010517;
  overflow: hidden;
  display: inline-block;
  margin-top: 0px;
  .box {
    width: 260px;
    padding: 0px 32px;
    display: flex;
    align-items: center;
    background: #fafbfb;
    box-sizing: border-box;
    .yuan {
      display: inline-block;
      border-radius: 50%;
      text-align: center;
      width: 21px;
      height: 21px;
      line-height: 21px;
      box-sizing: border-box;
      margin-right: 8px;
      background: #999999;
      color: #ffffff;
      font-size: 12px;
    }
    &.choose {
      z-index: 100;
      background: white;
      .title {
        font-weight: bold;
      }
    }
    .el-icon-success {
      margin-right: 8px;
      font-size: 21px;
      color: #35c08f;
    }
  }
  .content-box {
    height: 350px;
    display: flex;
    justify-content: space-between;
    .content-wrap {
      padding: 47px 0 0 60px;
      max-width: 360px;
      .text {
        font-size: 16px;
      }
      .tip {
        font-size: 12px;
        line-height: 16px;
        color: #666666;
        margin: 16px 0 36px;
      }
      .btn {
        color: #fff;
        background: #0560fd;
        border-radius: 3px;
      }
    }
    img {
      width: 240px;
      height: 240px;
      margin: 24px 100px 0 0;
    }
  }
}
.guidenced-content {
  margin-top: 15px;
  .analysis {
    height: 190px;
    margin-bottom: 15px;
    overflow: hidden;
    padding: 16px 0;
    box-sizing: border-box;
    .title {
      font-size: 14px;
      color: #010517;
      padding: 0 0 16px 26px;
      border-bottom: 1px solid #dcdfe6;
    }
    .list {
      display: flex;
      justify-content: space-between;
      .box-wrap {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 26px 40px 26px 24px;
        border-right: 1px solid #e5e9f2;
        &:last-child {
          border-right: none;
        }
        .box-img {
          width: 58px;
          height: 58px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #ecf2ff;
          border-radius: 50%;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
      .box-border {
        margin-right: 64px;
        border-right: 1px solid #e5e9f2;
        &:last-child {
          margin-right: 0;
          border-right: none;
        }
      }
      .box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        flex: 1;
        .text {
          font-size: 14px;
          color: #8a909d;
        }
        .number {
          font-size: 20px;
          font-weight: bold;
          color: #010517;
          margin: 12px 0 19px;
          line-height: 1;
        }
        .rate {
          color: #f23e55;
          font-size: 14px;
          display: flex;
          align-items: center;
          font-weight: bold;
          i {
            margin-left: 5px;
            font-size: 20px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .action {
    height: 395px;
    background: white;
    padding: 32px;
    box-sizing: border-box;
    margin-bottom: 15px;
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      border-radius: 16px;
      padding: 16px 32px;
      background-image: url('../../assets/images/userGuidance/date-bg.png');
      background-size: 100% 100%;
      background-color: #ecf2ff;
      .calendar {
        width: 30px;
        height: 30px;
        margin-right: 16px;
      }
      .nowDay {
        font-size: 12px;
        color: #010517;
      }
      .date {
        font-size: 14px;
        font-weight: bold;
        color: #010517;
        margin-top: 8px;
      }
    }
    .list {
      .box {
        display: flex;
        margin-bottom: 16px;
        &:nth-child(1),
        &:nth-child(4) {
          justify-content: flex-start;
        }
        &:nth-child(2),
        &:nth-child(5) {
          justify-content: center;
        }
        &:nth-child(3n) {
          justify-content: flex-end;
        }
        .action-wrap {
          width: 93%;
          height: 115px;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          .img-wrap {
            width: 48px;
            height: 48px;
            margin-bottom: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            img {
              width: 24px;
            }
          }
          .text {
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #010517;
          }
        }
      }
    }
  }
  .send-order {
    overflow: hidden;
    background: #ffffff;
    box-sizing: border-box;
    height: 470px;
    padding: 16px 24px;
    margin-bottom: 15px;
    .text {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      border-bottom: 1px solid #e5e9f2;
      padding: 0 30px 16px;
      .title {
        font-size: 14px;
        color: #8a909d;
      }
      .more {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
  .sale-analysis {
    height: 470px;
    background: #ffffff;
    padding: 23px 0;
    box-sizing: border-box;
    .title {
      margin-bottom: 16px;
      border-bottom: 1px solid #e5e9f2;
      padding: 0 30px 16px;
      color: #010517;
    }
  }
}

.goods-image {
  width: 64px;
  height: 64px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
}
</style>
